import { BaseApi } from './base';

class WebinarsApi extends BaseApi {
  constructor() {
    super('webinars');
  }

  getWebinars() {
    return this.get('');
  }
}

export default new WebinarsApi();
